"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../utils/constants");
var muiTablet16 = {
    paths: [
        {
            path: 'M0,1.00087166 C0,0.448105505 0.455760956,0 1.00247329,0 L10.9975267,0 C11.5511774,0 12,0.444630861 12,1.00087166 L12,14.9991283 C12,15.5518945 11.544239,16 10.9975267,16 L1.00247329,16 C0.448822582,16 0,15.5553691 0,14.9991283 L0,1.00087166 Z M2,2 L2,12 L10,12 L10,2 L2,2 Z M6,15 C6.55228475,15 7,14.5522847 7,14 C7,13.4477153 6.55228475,13 6,13 C5.44771525,13 5,13.4477153 5,14 C5,14.5522847 5.44771525,15 6,15 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Tablet',
    width: 12,
    height: 16,
};
var muiTablet24 = {
    paths: [
        {
            path: 'M17.0066023,0 C17.5552407,0 18,0.44746922 18,1.00069463 L18,22.9993054 C18,23.5519738 17.5550537,24 17.0066023,24 L0.993397683,24 C0.444759292,24 0,23.5525308 0,22.9993054 L0,1.00069463 C0,0.448026248 0.444946289,0 0.993397683,0 L17.0066023,0 Z M9,20 C8.44771525,20 8,20.4477153 8,21 C8,21.5522847 8.44771525,22 9,22 C9.55228475,22 10,21.5522847 10,21 C10,20.4477153 9.55228475,20 9,20 Z M16,2 L2,2 L2,18 L16,18 L16,2 Z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'Tablet',
    width: 18,
    height: 24,
};
var muiTablet = {
    base: muiTablet16,
    smIcon: muiTablet16,
    lgIcon: muiTablet24,
};
exports.muiTablet = muiTablet;
//# sourceMappingURL=tablet.js.map